import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { PACKAGES_BASE_QUERY_KEY } from '@/api/packages/get-packages-dashboard'
import { resetQueries } from '@/utils/api'

interface BulkDeletePackagesRequest {
  ids: number[]
}

export const bulkDeletePackages = async (data: BulkDeletePackagesRequest): Promise<void> => {
  await authAPI.delete('/packages/bulk-delete-permanent', { data })
}

export const useBulkDeletePackages = () => {
  return useMutation({
    mutationFn: bulkDeletePackages,
    onSuccess: () => {
      resetQueries([PACKAGES_BASE_QUERY_KEY])
    },
  })
}
